import React from 'react'
import {IconIndex} from '../util/Icon'
import {i} from '../../i.js'

export default class Features extends React.Component {
  state={}
  renderFeatures() {
    return i.features.map((e,i)=>(
      <div key={i} className="feature is-revealing">
        <div className="feature-inner">
          <div className="feature-icon">
            <IconIndex i={i} />
          </div>
          <h3 className="feature-title">{e.name}</h3>
          <p className="text-sm">{e.description}</p>
        </div>
      </div>
    ))
  }
  render() {
    return (
      <section className="features section text-center">
        <div className="container">
          <div className="features-inner section-inner has-bottom-divider">
            <div className="features-wrap">
              {this.renderFeatures()}
            </div>
          </div>
        </div>
      </section>
    )
  }
}



// WEBPACK FOOTER //
// ./src/component/section/Features.js